import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const UserAdd = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M22.778 16.835C23.557 15.265 24 13.552 24 12C24 7.589 20.411 4 16 4C11.589 4 8 7.589 8 12C8 13.552 8.443 15.265 9.222 16.835C6.142 18.265 4 21.386 4 25C4 26.654 5.346 28 7 28H25C26.654 28 28 26.654 28 25C28 21.386 25.858 18.266 22.778 16.835ZM16 6C19.308 6 22 8.691 22 12C22 13.708 21.286 15.764 20.137 17.367C18.937 19.04 17.429 20 16 20C14.571 20 13.063 19.04 11.863 17.367C10.714 15.764 10 13.708 10 12C10 8.691 12.691 6 16 6ZM25 26H7C6.449 26 6 25.551 6 25C6 22.113 7.758 19.63 10.258 18.561C11.858 20.779 13.896 22 16 22C18.104 22 20.142 20.779 21.742 18.561C24.243 19.63 26 22.113 26 25C26 25.551 25.551 26 25 26Z" />
		<path d="M19 11H17V9C17 8.448 16.552 8 16 8C15.448 8 15 8.448 15 9V11H13C12.448 11 12 11.448 12 12C12 12.552 12.448 13 13 13H15V15C15 15.552 15.448 16 16 16C16.552 16 17 15.552 17 15V13H19C19.552 13 20 12.552 20 12C20 11.448 19.552 11 19 11Z" />
	</svg>
);

export default UserAdd;
